import { ChevronLeft } from "@mui/icons-material";
import {
  Box,
  Button,
  IconButton,
  Stack,
  Typography,
  useMediaQuery,
} from "@mui/material";
import { grey } from "@mui/material/colors";
import React from "react";
import { useNavigate } from "react-router";

const PageHeader = ({
  title,
  showBack,
  buttonTitle,
  buttonOnClick,
  rightComponent = null,
  textAlignedCenter = false,
  lead,
  isMobileHeader = false, // ✅ New prop
}) => {
  const navigate = useNavigate();
  const isMobile = useMediaQuery("(max-width: 480px)");

  return (
    <Box
      display="flex"
      alignItems="center"
      gap={1} // ✅ Reduced from gap={2}
      mb={{ xs: isMobileHeader ? 0 : 1, md: 4 }} // ✅ No margin bottom in mobile header
      sx={{
        textAlign: textAlignedCenter ? "center" : "inherit",
        py: isMobileHeader ? 0.5 : 0, // ✅ Minimal vertical padding in header
      }}
    >
      {showBack && (
        <IconButton 
          onClick={() => navigate(-1)}
          sx={{
            p: isMobileHeader ? 0.5 : 1, // ✅ Smaller padding when in mobile header
          }}
        >
          <ChevronLeft />
        </IconButton>
      )}
      <Stack flex={1}>
        <Typography 
          variant={isMobile ? "body2" : "h6"} // ✅ Reduced body1 to body2 on mobile
          fontWeight={500}
          sx={{ lineHeight: isMobileHeader ? 1.2 : 1.5 }} // ✅ Tighter line height
        >
          {title}
        </Typography>
        {!isMobile && lead && (
          <Typography variant="body2" color={grey[600]} fontWeight={500}>
            {lead}
          </Typography>
        )}
      </Stack>

      {buttonTitle && (
        <Button variant="outlined" sx={{ ml: "auto" }} onClick={buttonOnClick}>
          {buttonTitle}
        </Button>
      )}
      {rightComponent && <Box ml="auto">{rightComponent}</Box>}
    </Box>
  );
};

export default PageHeader;
